<script>
  import { createEventDispatcher } from 'svelte';
  import { fade } from 'svelte/transition';
  import { expoOut } from 'svelte/easing';
  import { isMobile } from '$stores/media.store';
  import MobileDrawer from './MobileDrawer.svelte';

  const dispatch = createEventDispatcher();

  // export let z = 'z-40';
  export let py = 'py-9';
  export let px = 'px-7';
  export let rounded = 'rounded-[20px]';
  export let bg = 'bg-white';
  export let collapsable = true;
  export let isCollapsed = true;
  export let wrapperClass = '';

  function close(event) {
    if (event.target === overlay) {
      dispatch('ModalClose');
    }
  }

  let overlay;
</script>

<!-- Desktop -->
<button
  class="{wrapperClass} flex flex-col items-center justify-center flex-grow fixed top-0 left-0 w-full h-full p-10 backdrop-blur-lg bg-color-black-base bg-opacity-50 z-40"
  on:click={close}
  bind:this={overlay}
  transition:fade|global={{ duration: 200, easing: expoOut }}
>
  {#if !$isMobile}
    <div class="lg:block bg-white overscroll-contain {px} {py} {rounded} {$$props.class}">
      <slot />
    </div>
  {:else}
    <MobileDrawer bind:isCollapsed {bg} on:ModalClose {collapsable}>
      <slot />
    </MobileDrawer>
  {/if}
</button>

<style>
  .z-override {
    z-index: var(--z, 40);
  }
</style>
